import FullModalAccordion from './FullModalAccordion';
export default FullModalAccordion;
